import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <mask id="mask0_13822_5083" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_13822_5083)">
      <path d="M10.5028 10L6.66943 6.16667L7.8361 5L12.8361 10L7.8361 15L6.66943 13.8333L10.5028 10Z" fill="#0B57D0" />
    </g>
  </svg>
);

export default Icon;
